<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Skeleton from '@uiKit/elements/Skeleton.vue'
</script>

<template>
  <Box direction="col" gap="2" class="tl__list">
    <Box v-for="i in 5" :key="i" class="tl__row">
      <Box align="center" gap="3" class="tl__col-detail">
        <Skeleton animation="wave" width="46px" height="46px" border-radius="12px" />
        <Box direction="col" gap="1" grow>
          <Skeleton animation="wave" width="140px" height="14px" border-radius="4px" />
          <Skeleton animation="wave" width="100px" height="12px" border-radius="4px" />
        </Box>
      </Box>
      <Box direction="col" align="center" gap="1" class="tl__col-date">
        <Skeleton animation="wave" width="80px" height="12px" border-radius="4px" />
        <Skeleton animation="wave" width="60px" height="12px" border-radius="4px" />
      </Box>
      <Box align="center" justify="center" class="tl__col-txnid">
        <Skeleton animation="wave" width="70px" height="14px" border-radius="4px" />
      </Box>
      <Box align="center" justify="center" class="tl__col-amount">
        <Skeleton animation="wave" width="90px" height="16px" border-radius="4px" />
      </Box>
      <Box align="center" justify="center" class="tl__col-status">
        <Skeleton animation="wave" width="100px" height="26px" border-radius="26px" />
      </Box>
      <Box align="center" justify="center" class="tl__col-view">
        <Skeleton animation="wave" width="80px" height="14px" border-radius="4px" />
      </Box>
    </Box>
  </Box>
</template>

<style scoped>
.tl__row {
  display: grid;
  grid-template-columns: minmax(220px, 2.4fr) minmax(120px, 1.4fr) minmax(150px, 1.6fr) minmax(110px, 1.2fr) minmax(110px, 1.2fr) minmax(100px, 1fr);
  column-gap: 0.75rem;
  align-items: center;
  background: var(--p-surface-0);
  border: 1px solid var(--p-content-border-color);
  border-radius: 10px;
  padding: 14px 1.25rem;
  min-height: 72px;
  box-sizing: border-box;
}

.tl__col-detail {
  min-width: 0;
  padding-right: 14px;
}

.tl__col-date,
.tl__col-txnid,
.tl__col-amount,
.tl__col-status,
.tl__col-view {
  min-width: 0;
}

@media (max-width: 992px) {
  .tl__row {
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto auto auto;
    grid-template-areas:
      'detail  amount'
      'date    date'
      'txnid   txnid'
      'status  view';
    gap: 5px 8px;
    align-items: start;
    padding: 14px 1rem;
    min-height: unset;
  }

  .tl__col-detail { grid-area: detail; }
  .tl__col-amount { grid-area: amount; justify-content: flex-end; }
  .tl__col-date { grid-area: date; }
  .tl__col-txnid { grid-area: txnid; }
  .tl__col-status { grid-area: status; }
  .tl__col-view { grid-area: view; justify-content: flex-end; }
}
</style>
